import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { batchApplyStatus } from '@/constants/coupon';
import { typeMapToText } from '@/common/enums/discount-type';

// 项目头部折扣信息
export default {
  name: 'ShowDetailDiscount',
  props: {
    promotional: {
      type: Object,
      value: {}
    },
    performanceId: {
      type: Number,
      value: 0
    },
    promotionFloorTitles: {
      type: Array
    }
  },
  data: function data() {
    return {
      showMask: false,
      typeMapToText: typeMapToText,
      showShandow: false
    };
  },
  mounted: function mounted() {
    window.seedAction({
      evt: 'view',
      bid: 'b_tm9bjlny',
      cid: 'c_c21utqjf',
      abtest: 1,
      custom: {
        performance_id: this.performanceId
      }
    });
    this.setShowMask();
    this.calcShowShandow();
  },
  computed: {
    // 是否有优惠信息
    hasDiscount: function hasDiscount() {
      var promotionDetails = this.promotional.promotionDetails;
      return promotionDetails && promotionDetails.length > 0;
    },
    businessBatchNum: function businessBatchNum() {
      // 优惠券数量
      return this.promotional.businessBatchList && this.promotional.businessBatchList.length || 0;
    },
    // // 折扣(1)、套票(1)、优惠券(0 - 4)，最多展示4个
    getbusinessBatchList: function getbusinessBatchList() {
      // 展示的优惠券
      if (!this.promotional.businessBatchList) return [];
      // 除了兑金券其他券，去重
      var isNotConversionBusinessBatchLists = this.promotional.businessBatchList.filter(function (item) {
        return item.type !== 2;
      });
      var businessBatchLists = isNotConversionBusinessBatchLists.reduce(function (accumulator, current) {
        var exists = accumulator.find(function (item) {
          return item.batchId === current.batchId;
        });
        if (!exists) {
          accumulator = accumulator.concat(current);
        }
        return accumulator;
      }, []).map(function (item) {
        if (item.couponTagStr.match(/[0-9]+(\.[0-9]+)?/)) {
          return Object.assign({}, item, {
            couponTagStr: item.couponTagStr.replace(/[0-9]+(\.[0-9]+)?/g, function (regItem) {
              return " ".concat(regItem, " ");
            })
          });
        }
      });

      //兑换券
      var isConversionBusinessBatchLists = this.promotional.businessBatchList.filter(function (item) {
        return item.type === 2;
      });
      if (isConversionBusinessBatchLists.length === 0) {
        return businessBatchLists;
      }
      // 未领兑金券
      var notgetIsConversionBusinessBatchLists = isConversionBusinessBatchLists.filter(function (item) {
        return item.status === 1;
      });
      var notgetIsConversionRes = notgetIsConversionBusinessBatchLists.length > 0 ? [{
        type: 2,
        num: notgetIsConversionBusinessBatchLists.length,
        couponTagStr: "\u5F20\u5151\u6362\u5238",
        status: 1
      }] : [];
      // 已领兑金券
      var getIsConversionBusinessBatchLists = isConversionBusinessBatchLists.filter(function (item) {
        return item.status === 2;
      });
      var getIsConversionRes = getIsConversionBusinessBatchLists.length > 0 ? [{
        type: 2,
        num: getIsConversionBusinessBatchLists.length,
        couponTagStr: "\u5F20\u5151\u6362\u5238",
        status: 2
      }] : [];
      //未领其他券
      var notGetOtherBusinessBatchLists = businessBatchLists.filter(function (item) {
        return item.status === 1;
      });
      //已领其他券
      var getOtherBusinessBatchLists = businessBatchLists.filter(function (item) {
        return item.status === 2;
      });
      return [].concat(notgetIsConversionRes, _toConsumableArray(notGetOtherBusinessBatchLists), getIsConversionRes, _toConsumableArray(getOtherBusinessBatchLists));
    },
    canReceive: function canReceive() {
      // 是否存在可领的优惠券
      if (!this.businessBatchNum) return false;
      return this.promotional.businessBatchList.some(function (item) {
        return ![batchApplyStatus.RECEIVED, batchApplyStatus.ROBBED].includes(item.status);
      });
    },
    promotionTitleHtml: function promotionTitleHtml() {
      if (!this.promotionFloorTitles) {
        return null;
      }
      var res = this.promotionFloorTitles.map(function (item) {
        var promotionShowText = item.promotionShowText,
          ticketShowText = item.ticketShowText;
        return {
          promotionShowText: promotionShowText.replace(/[0-9]+(.[0-9]+)?/g, function (regItem) {
            return ' ' + regItem + ' ';
          }),
          ticketShowText: ticketShowText.replace(/[0-9]+(.[0-9]+)?/g, function (regItem) {
            return ' ' + regItem + ' ';
          })
        };
      });
      return res;
    },
    discountFloorLength: function discountFloorLength() {
      var len = 0;
      if (this.promotionTitleHtml && this.promotionTitleHtml.length > 0) {
        len++;
      }
      if (this.getbusinessBatchList && this.getbusinessBatchList.length > 0) {
        len++;
      }
      return len;
    }
  },
  methods: {
    // 点击展示优惠信息
    togglePromotion: function togglePromotion() {
      this.$emit('togglePromotion');
    },
    calcShowShandow: function calcShowShandow() {
      try {
        var width1 = document.getElementById('ticket-scroll-wrap').offsetWidth || 0;
        var listEle2 = document.getElementById('ticket-scroll-content');
        var listEle3 = document.getElementById('tagCon-scroll-content');
        var width2 = 0;
        var width3 = 0;
        if (listEle2 && listEle2.childNodes.length) {
          width2 = listEle2.childNodes[listEle2.childNodes.length - 1].clientWidth + listEle2.childNodes[listEle2.childNodes.length - 1].offsetLeft;
        }
        if (listEle3 && listEle3.childNodes.length) {
          width3 = listEle3.childNodes[listEle3.childNodes.length - 1].clientWidth + listEle3.childNodes[listEle3.childNodes.length - 1].offsetLeft;
        }
        if (width1 < width2 || width1 < width3) {
          this.showShandow = true;
        }
      } catch (e) {
        console.error(e);
      }
    },
    setShowMask: function setShowMask() {
      var _this = this;
      this.$nextTick(function () {
        var clientWidth = window.document.body.clientWidth;
        var maxTagWidth = clientWidth - 80;
        var tagConEle = _this.$refs.tagCon;
        var showMask = false;
        if (tagConEle && tagConEle.scrollWidth > maxTagWidth) {
          showMask = true;
        }
        _this.showMask = showMask;
      });
    }
  }
};